webpackJsonp([43369700788870],{

/***/ 419:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  max-width: 700px;\n  margin: 4rem auto;\n  padding: 3rem 2rem;\n  border-radius: 6px;\n  border: solid 1px rgba(0, 0, 0, 0.2);\n\n  ', ';\n  h1 {\n    font-size: 46px;\n\n    ', ';\n\n    ', ';\n  }\n\n  form {\n    margin-bottom: 0;\n  }\n'], ['\n  max-width: 700px;\n  margin: 4rem auto;\n  padding: 3rem 2rem;\n  border-radius: 6px;\n  border: solid 1px rgba(0, 0, 0, 0.2);\n\n  ', ';\n  h1 {\n    font-size: 46px;\n\n    ', ';\n\n    ', ';\n  }\n\n  form {\n    margin-bottom: 0;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    border: none;\n    margin: 3rem auto 0;\n    padding: 2rem 0 0 0;\n  '], ['\n    border: none;\n    margin: 3rem auto 0;\n    padding: 2rem 0 0 0;\n  ']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n    font-size: 38px;\n  '], ['\n    font-size: 38px;\n  ']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n    font-size: 32px;\n  '], ['\n    font-size: 32px;\n  ']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  margin-bottom: 1rem;\n\n  label {\n    line-height: 2;\n    color: #333333;\n\n    input {\n      height: 36px;\n      border-radius: 6px;\n      border: solid 1px rgba(0, 0, 0, 0.2);\n      padding: 0 0.5rem;\n      width: 100%;\n\n      &:-moz-ui-invalid:not(output) {\n        box-shadow: none;\n      }\n    }\n  }\n'], ['\n  margin-bottom: 1rem;\n\n  label {\n    line-height: 2;\n    color: #333333;\n\n    input {\n      height: 36px;\n      border-radius: 6px;\n      border: solid 1px rgba(0, 0, 0, 0.2);\n      padding: 0 0.5rem;\n      width: 100%;\n\n      &:-moz-ui-invalid:not(output) {\n        box-shadow: none;\n      }\n    }\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  width: 175px;\n  height: 46px;\n'], ['\n  width: 175px;\n  height: 46px;\n']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  width: 100%;\n\n  input {\n    width: calc(100% - 0.5rem);\n\n    &:nth-child(odd) {\n      margin-right: 0.5rem;\n    }\n    &:nth-child(even) {\n      margin-left: 0.5rem;\n    }\n  }\n'], ['\n  display: flex;\n  width: 100%;\n\n  input {\n    width: calc(100% - 0.5rem);\n\n    &:nth-child(odd) {\n      margin-right: 0.5rem;\n    }\n    &:nth-child(even) {\n      margin-left: 0.5rem;\n    }\n  }\n']),
	    _templateObject8 = _taggedTemplateLiteralLoose(['\n  font-style: italic;\n  font-size: 0.8rem;\n'], ['\n  font-style: italic;\n  font-size: 0.8rem;\n']),
	    _templateObject9 = _taggedTemplateLiteralLoose(['\n  resize: none;\n  width: 100%;\n  height: 175px;\n  border-radius: 6px;\n  border: solid 1px rgba(0, 0, 0, 0.2);\n  padding: 0 0.5rem;\n\n  &:-moz-ui-invalid:not(output) {\n    box-shadow: none;\n  }\n'], ['\n  resize: none;\n  width: 100%;\n  height: 175px;\n  border-radius: 6px;\n  border: solid 1px rgba(0, 0, 0, 0.2);\n  padding: 0 0.5rem;\n\n  &:-moz-ui-invalid:not(output) {\n    box-shadow: none;\n  }\n']),
	    _templateObject10 = _taggedTemplateLiteralLoose(['\n  color: #338a1a;\n'], ['\n  color: #338a1a;\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(68);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Container = __webpack_require__(35);
	
	var _FancyButton = __webpack_require__(128);
	
	var _FancyButton2 = _interopRequireDefault(_FancyButton);
	
	var _theme = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var FormWrapper = _styledComponents2.default.div(_templateObject, _theme.media.forSmallOnly(_templateObject2), _theme.media.forSmallMediumOnly(_templateObject3), _theme.media.forSmallOnly(_templateObject4));
	
	var Inputfield = _styledComponents2.default.div(_templateObject5);
	
	var SubmitButton = _FancyButton2.default.extend(_templateObject6);
	
	var NameFields = _styledComponents2.default.div(_templateObject7);
	
	var Optional = _styledComponents2.default.span(_templateObject8);
	
	var TextArea = _styledComponents2.default.textarea(_templateObject9);
	
	var WoodsProduceLink = _styledComponents2.default.a(_templateObject10);
	
	function encode(data) {
	  return Object.keys(data).map(function (key) {
	    return encodeURIComponent(key) + '=' + encodeURIComponent(data[key]);
	  }).join('&');
	}
	
	var Contact = function (_React$Component) {
	  _inherits(Contact, _React$Component);
	
	  function Contact(props) {
	    _classCallCheck(this, Contact);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.handleChange = function (e) {
	      var _this$setState;
	
	      _this.setState((_this$setState = {}, _this$setState[e.target.name] = e.target.value, _this$setState));
	    };
	
	    _this.handleSubmit = function (e) {
	      fetch('/', {
	        method: 'POST',
	        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	        body: encode(_extends({ 'form-name': 'contact' }, _this.state))
	      }).then(function () {
	        return (0, _gatsbyLink.navigateTo)('/thank-you');
	      }).catch(function (error) {
	        return alert(error);
	      });
	
	      e.preventDefault();
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  Contact.prototype.render = function render() {
	    return _react2.default.createElement(
	      _Container.Container,
	      null,
	      _react2.default.createElement(
	        FormWrapper,
	        null,
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Contact Us'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Please reach out with any questions you have, and we\'ll get back to you in the next couple days.',
	          ' ',
	          _react2.default.createElement(
	            WoodsProduceLink,
	            {
	              href: 'https://woodsproduce.com',
	              target: '_blank',
	              rel: 'noopener noreferrer'
	            },
	            'Visit Woods Produce \u2192'
	          )
	        ),
	        _react2.default.createElement(
	          'form',
	          {
	            name: 'contact',
	            method: 'post',
	            action: '/thank-you',
	            'data-netlify': 'true',
	            'data-netlify-honeypot': 'bot-field',
	            onSubmit: this.handleSubmit
	          },
	          _react2.default.createElement(
	            Inputfield,
	            { hidden: true },
	            _react2.default.createElement(
	              'label',
	              null,
	              'Don\u2019t fill this out:',
	              ' ',
	              _react2.default.createElement('input', { name: 'bot-field', onChange: this.handleChange })
	            )
	          ),
	          _react2.default.createElement(
	            Inputfield,
	            null,
	            _react2.default.createElement(
	              'label',
	              null,
	              'Name',
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                NameFields,
	                null,
	                _react2.default.createElement('input', {
	                  type: 'text',
	                  name: 'firstName',
	                  required: true,
	                  onChange: this.handleChange,
	                  placeholder: 'First'
	                }),
	                _react2.default.createElement('input', {
	                  type: 'text',
	                  name: 'lastName',
	                  required: true,
	                  onChange: this.handleChange,
	                  placeholder: 'Last'
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            Inputfield,
	            null,
	            _react2.default.createElement(
	              'label',
	              null,
	              'Email',
	              _react2.default.createElement('br', null),
	              _react2.default.createElement('input', {
	                type: 'email',
	                name: 'email',
	                required: true,
	                onChange: this.handleChange
	              })
	            )
	          ),
	          _react2.default.createElement(
	            Inputfield,
	            null,
	            _react2.default.createElement(
	              'label',
	              null,
	              'Phone - ',
	              _react2.default.createElement(
	                Optional,
	                null,
	                'Optional'
	              ),
	              _react2.default.createElement('br', null),
	              _react2.default.createElement('input', { type: 'phone', name: 'phone', onChange: this.handleChange })
	            )
	          ),
	          _react2.default.createElement(
	            Inputfield,
	            null,
	            _react2.default.createElement(
	              'label',
	              null,
	              'Message',
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(TextArea, {
	                name: 'message',
	                required: true,
	                onChange: this.handleChange
	              })
	            )
	          ),
	          _react2.default.createElement(
	            Inputfield,
	            null,
	            _react2.default.createElement(
	              SubmitButton,
	              { type: 'submit' },
	              'Send'
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Contact;
	}(_react2.default.Component);
	
	exports.default = Contact;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-us-js-ef5688beedbfb147d96a.js